export default "__VITE_ASSET__BQjva56q__"